import axios from 'axios';
import {
  GET_ONBOARDING_QUESTIONS,
  SUBMIT_ONBOARDING_ANSWERS,
  CHECK_ONBOARDING_STATUS,
  ONBOARDING_LOADING,
  GET_ERRORS,
  CLEAR_ERRORS,
  USER_LOADED
} from './types';
import { tokenConfig, loadUser } from './authActions';

// Get onboarding questions
export const getOnboardingQuestions = () => (dispatch, getState) => {
  dispatch(setOnboardingLoading());
  
  axios
    .get('/api/onboarding/questions', tokenConfig(getState))
    .then(res => {
      dispatch({
        type: GET_ONBOARDING_QUESTIONS,
        payload: res.data
      });
    })
    .catch(err => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || { msg: 'Network error' }
      });
    });
};

// Submit onboarding answers
export const submitOnboardingAnswers = (answers) => (dispatch, getState) => {
  dispatch(setOnboardingLoading());
  dispatch({ type: CLEAR_ERRORS });

  // Don't stringify manually - let axios handle it with the correct Content-Type header
  const body = { answers };

  axios
    .post('/api/onboarding/submit', body, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: SUBMIT_ONBOARDING_ANSWERS,
        payload: res.data
      });
      // Update user data to reflect hasCompletedOnboarding: true
      // If the response includes the updated user, dispatch USER_LOADED immediately
      if (res.data.user) {
        dispatch({
          type: USER_LOADED,
          payload: res.data.user
        });
      } else {
        // Fallback: fetch user data
        dispatch(loadUser());
      }
    })
    .catch(err => {
      // Log error details to console for debugging
      console.error('❌ Onboarding submission error:', {
        status: err.response?.status,
        statusText: err.response?.statusText,
        message: err.response?.data?.msg || err.message,
        fullError: err.response?.data,
        url: err.config?.url
      });
      
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || { msg: 'Network error' }
      });
    });
};

// Check onboarding status
export const checkOnboardingStatus = () => (dispatch, getState) => {
  dispatch(setOnboardingLoading());
  
  axios
    .get('/api/onboarding/status', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: CHECK_ONBOARDING_STATUS,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response?.data || { msg: 'Network error' }
      })
    );
};

// Set loading state
export const setOnboardingLoading = () => {
  return {
    type: ONBOARDING_LOADING
  };
};

// Assign path directly (skip assessment, used for referral links with pathwayId)
// Returns a promise so the component can navigate after completion
export const assignPathDirectly = (pathwayId) => (dispatch, getState) => {
  dispatch(setOnboardingLoading());

  return axios
    .post('/api/onboarding/assign-path', { pathwayId }, tokenConfig(getState))
    .then(res => {
      if (res.data.user) {
        dispatch({ type: USER_LOADED, payload: res.data.user });
      } else {
        dispatch(loadUser());
      }
      return res.data;
    })
    .catch(err => {
      console.error('Failed to assign path directly:', err.response?.data || err.message);
      sessionStorage.removeItem('referral_pathwayId');
      throw err;
    });
};

// Clear onboarding state
export const clearOnboarding = () => {
  return {
    type: 'CLEAR_ONBOARDING'
  };
};
